import { Component, AfterViewInit, ElementRef, Input, OnChanges, ViewChild, SimpleChanges } from '@angular/core';

import { BaseFilterCollapse, BaseFilterCollapseService } from '../../../../core';
import { TransportadoraFilter } from './transportadora-filter';
import { TransportadoraSituacoes } from '../transportadora-situacao';

@Component({
    selector: 'sgt-transportadora-filter-collapse',
    templateUrl: './transportadora-filter-collapse.component.html',
    styleUrls: ['./transportadora-filter-collapse.component.less']
})
export class TransportadoraFilterCollapseComponent implements BaseFilterCollapse, OnChanges, AfterViewInit {
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = false;


    @Input() filter: TransportadoraFilter;
    situacoes = TransportadoraSituacoes;

    // Valores padrões
    @Input() situacao: number;

    constructor(private baseFilterCollapseService: BaseFilterCollapseService) { }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }


    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);
        this.filter.situacao = this.situacao; // Setando a situação padrão (se hover uma)
    }

    /** Ao alterar a data de cadastro inicial/final */
    onChangeDataCadastro(date: Date) {
        if (date) {
            this.isFilterDirty = true;
        }
    }
}
